<template>
  <div class="ApplCard">
    <div class="ApplCard-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        申请新卡
      </div>
      <div class="ApplCard-InfoTion">
        <div class="ApplCard-CardNumber ApplCard-default">
          <span>申请人姓名:</span>
          <el-input v-model="ApFullName" placeholder="请输入申请人姓名" @input="ApFuName()"></el-input>
        </div>
        <div class="ApplCard-CardNumber ApplCard-default">
          <span>手机号码:</span>
          <el-input type="number" v-model="ApPhoneNum" placeholder="请输入手机号码" @input="ApPhoneBer()"></el-input>
        </div>
        <div class="ApplCard-CardNumber ApplCard-default">
          <span>身份证号:</span>
          <el-input v-model="ApIdNum" placeholder="请输入身份证号" @input="ApIdBer()"></el-input>
        </div>
        <div class="ApplCard-CardNumber ApplCard-default">
          <span>开户行名称:</span>
          <el-input v-model="ApBankDepo" placeholder="请输入开户行名称" @input="ApBankPoit()"></el-input>
        </div>
        <div class="ApplCard-CardNumber ApplCard-default">
          <span>银行卡号:</span>
          <el-input v-model="ApBankNum" placeholder="请输入银行卡号" @input="ApBankBer()"></el-input>
        </div>
        <!-- <div class="ApplCard-CardNumber ApplCard-default">
          <span>推荐人:</span>
          <el-input v-model="ApRefeEnce" placeholder="请输入推荐人姓名" @input="ApRefeEncs()"></el-input>
        </div> -->
        <!-- <div class="ApplCard-CardNumber">
          <span>推荐人电话:</span>
          <el-input type="number" v-model="ApTelePhon" placeholder="请输入推荐人电话" @input="ApTelePhoe()"></el-input>
        </div> -->
      </div>
      <button class="ApplCard-confirm" @click="applfrnk()">确认</button>
      <!-- <div class="ApplCard-tips">工作人员会在三个工作日内与您联系</div> -->
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + applfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{appltips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + applsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{appltips}}</p>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      ApFullName: '',
      ApPhoneNum: '',
      ApIdNum: '',
      ApBankDepo: '',
      ApBankNum: '',
      // ApRefeEnce: '',
      // ApTelePhon: '',
      applfail: 'none',
      appltips: '',
      applsucs: 'none',
      loginID: ''
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
  },
  mounted () {

  },
  methods: {
    // 获取输入的姓名
    ApFuName(){
      // console.log(this.ApFullName);
    },
    // 获取输入的手机号码
    ApPhoneBer(){
      // console.log(this.ApPhoneNum);
    },
    // 获取输入的身份证号
    ApIdBer(){
      // console.log(this.ApIdNum);
    },
    // 获取输入的开户行名称
    ApBankPoit(){
      // console.log(this.ApBankDepo);
    },
    // 获取输入的银行卡号
    ApBankBer(){
      // console.log(this.ApBankNum);
    },
    // 获取推荐人姓名
    ApRefeEncs(){
      // console.log(this.ApRefeEnce);
    },
    // 获取推荐人电话
    ApTelePhoe(){
      // console.log(this.ApTelePhon);
    },
    // 点击确认触发
    applfrnk(){
      if(this.ApFullName == ''){
        this.appltips = '姓名不能为空';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }else if(this.ApPhoneNum == ''){
        this.appltips = '手机号不能为空';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }else if(!(/^1[3456789]\d{9}$/.test(this.ApPhoneNum))){
        this.appltips = '手机号格式错误';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }else if(this.ApIdNum == ''){
        this.appltips = '身份证号不能为空';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }else if(this.ApBankDepo == ''){
        this.appltips = '开户行名称不能为空';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }else if(this.ApBankNum == ''){
        this.appltips = '银行卡号不能为空';
        this.applfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.applfail = 'none';
        },1200)
      }
      // else if(this.ApRefeEnce == ''){
      //   this.appltips = '推荐人姓名不能为空';
      //   this.applfail = 'block';
      //   const _this = this;
      //   setTimeout(function(){
      //     _this.applfail = 'none';
      //   },1200)
      // }else if(this.ApTelePhon == ''){
      //   this.appltips = '推荐人电话不能为空';
      //   this.applfail = 'block';
      //   const _this = this;
      //   setTimeout(function(){
      //     _this.applfail = 'none';
      //   },1200)
      // }else if(!(/^1[3456789]\d{9}$/.test(this.ApTelePhon))){
      //   this.appltips = '推荐人电话格式错误';
      //   this.applfail = 'block';
      //   const _this = this;
      //   setTimeout(function(){
      //     _this.applfail = 'none';
      //   },1200)
      // }
      else{
        this.$axios.post('app/applyForNewCard',this.$qs.stringify({
          token: this.loginID,
          cardtype: '3',
          lxdh: this.ApPhoneNum,
          name: this.ApFullName,
          Sfzhm: this.ApIdNum,
          // tjr: this.ApRefeEnce,
          // tjrdh: this.ApTelePhon,
          bankcard: this.ApBankNum,
          bankcardadd: this.ApBankDepo
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.code == '200'){
            this.appltips = res.data.msg;
            this.applsucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.applsucs = 'none';
              _this.$router.push({name: 'NewCape'});
            },1200)
          }else{
            this.appltips = res.data.msg;
            this.applfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.applfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/ApplCard.css";
</style>